import { render, staticRenderFns } from "./aliyunCaptcha.vue?vue&type=template&id=13abbb9c&scoped=true"
import script from "./aliyunCaptcha.vue?vue&type=script&lang=js"
export * from "./aliyunCaptcha.vue?vue&type=script&lang=js"
import style0 from "./aliyunCaptcha.vue?vue&type=style&index=0&id=13abbb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4_39e6b3bc5413fb15da5f6259cbfb3172/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13abbb9c",
  null
  
)

export default component.exports